"use strict";

define('view/report.preview.list',['require','exports','module','uikit/uikit','./page.list','moment'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var PageList = require('./page.list');
  var moment = require('moment');
  var ReportPreviewView = UIKit.Table.extend({
    attributes: {
      style: 'table-layout: fixed; min-width: 100%;'
    },
    initialize: function initialize() {
      this.configureColumnsFromData();
      UIKit.Table.prototype.initialize.apply(this, arguments);
    },
    configureColumnsFromData: function configureColumnsFromData() {
      var columns = this.getOption('columns');
      var textFormatter = function textFormatter(value) {
        return value ? value : '--';
      };
      var dateFormatter = function dateFormatter(value) {
        return !!value ? moment(value).format('L') : '--';
      };
      columns = _.map(columns, function (column) {
        var columnFormatter = column.name.indexOf('Date') !== -1 ? dateFormatter : textFormatter;
        return {
          text: column.displayName,
          data: column.name,
          formatter: columnFormatter
        };
      });
      this.options.columns = columns;
    },
    onHeaderRender: function onHeaderRender() {
      this.headerView.$('th').prop('width', 200);
    }
  });
  module.exports = ReportPreviewView;
});

